import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { FeatureFlagsService } from '@principle-theorem/ng-feature-flags';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import { safeCombineLatest, shareReplayCold } from '@principle-theorem/shared';
import { type Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { type IAiSuiteFeature } from './ai-suite-feature';
import { AI_SUITE_FEATURES } from './ai-suite-feature-registry';

/**
 * Generic AI feature host. Do not add per-feature logic here.
 * This component acts as the shell container that dynamically renders
 * registered AI feature dashboards based on feature flags.
 */
@Component({
  selector: 'pr-ai-suite-shell',
  templateUrl: './ai-suite-shell.component.html',
  styleUrls: ['./ai-suite-shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgCommonModule, RouterModule, MatIconModule],
})
export class AiSuiteShellComponent {
  private readonly _featureFlags = inject(FeatureFlagsService);

  enabledFeatures$: Observable<IAiSuiteFeature[]> = safeCombineLatest(
    AI_SUITE_FEATURES.map((feature) =>
      this._featureFlags
        .isFeatureEnabled$(feature.feature)
        .pipe(map((enabled) => ({ feature, enabled })))
    )
  ).pipe(
    map((results) =>
      results.filter((result) => result.enabled).map((result) => result.feature)
    ),
    shareReplayCold()
  );
}
